import Header from '../../../__Layout/Header';
import React from "react";
import {Link, useParams } from 'react-router-dom';
import {pageUrl} from "../../../utils/constants/constants";
import Loader from '../../../utils/Loader';
import {useGetStudentCourseTopicDetailQuery} from "../../../Services/api";
export default function OpenPdf() {   
    const {course_id, lpid } = useParams();
    const lpidParam= 'lpid='+lpid;
    const {
        data: CourseTopicDetail,
        isLoading: isGetLoadingDetail,
    } = useGetStudentCourseTopicDetailQuery({ pageUrl, params: lpidParam });
    if(isGetLoadingDetail) return  <Loader></Loader>

    return (
            <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Relevant Questions</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                       <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">Relevant Questions</button>
                        </li>
                        <Link to={`/student-course-topic/${course_id}/${lpid}`} className='btn btn-warning pull-right'>
                                    Back
                        </Link>
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                
                                <table className="table table-bordered">
                                            
                                            { 
                                                CourseTopicDetail?.data?.map((item,index) => {
                                                return (
                                                        <tbody  key={index}>
                                                            
                                                            <tr>
                                                                <td>
                                                                    <Link className='text-dark' to={item.relevant_question}>File</Link>
                                                                </td>
                                                            </tr>
                                                           
                                                            
                                                        </tbody>                                        
                                                    )  
                                                })  
                                            } 
                                           
                                        </table>
                                </div>
                            </section>  
                        </div>
                    </div>
                </div>
            </div>
            </main>
        </div>
    );
}
